import * as Yup from 'yup';

/**
 * 礼品包装
 */
export interface GiftWrapInfo {
  /**
   * 包装数(包装数,收费合计,pos小票编号不能全为空)
   */
  num?: string;
  /**
   * 收费合计
   */
  money?: string;
  /**
   * pos小票编号
   */
  pos_no?: string;
}

/**
 * 礼品包装表单默认值
 */
export const defaultGiftWrapInfo: GiftWrapInfo = {
  num: '',
  money: '0',
  pos_no: '',
};

/**
 * 礼品包装表单校验
 */
export const giftwrapSchema = Yup.object().shape(
  {
    num: Yup.string().required('请输入包装数').matches(/^[1-9]\d*$/, '请输入正确的包装数').max(5, '包装数不能大于99999'),
    money: Yup.string().required('请输入收费合计').matches(/^\d+(\.(\d)*)?$/, '请输入正确的金额'),
  },
  [
    ['num', 'money'],
    ['num', 'pos_no'],
    ['money', 'pos_no'],
  ]
);